<template>
  <el-dialog
    class="radish-dia"
    title="解释"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="dialogVisible = false"
  >
    <div v-if="recommendReason" class="radish-dia-body" style="padding-bottom: 15px;">
      <p>
        1) 根据项目中人选
        <span v-if="recommendReason.person.姓名" class="radish-btn-text" @click="showRadish(recommendReason.person)">
          {{ recommendReason.person.姓名 }}
        </span>
        <span v-else style="color:#ccc">{{ recommendReason.person._id }}(已删除)</span> 推荐，两人的共同项目有
        <a v-for="pro in recommendReason.relatedProjs" :key="pro._id" :href="`#/project20/${pro._id}`" target="_blank">
          {{ pro.客户公司 + '-' + pro.项目名称 }}&nbsp;
        </a>
        等；
      </p>
      <p>
        2) 根据项目中&nbsp;
        <span v-for="person in recommendReason.relatedPersons" class="radish-btn-text" @click="showRadish(person)">
          {{ person.姓名 }}&nbsp;
        </span>
        等人选推荐，同在
        <a v-if="recommendReason.project.项目名称" :href="`#/project20/${recommendReason.project._id}`" target="_blank">
          {{ recommendReason.project.客户公司 + '-' + recommendReason.project.项目名称 }}
        </a>
        <span v-else style="color:#ccc">{{ recommendReason.project._id }}(已删除)</span> 项目中
      </p>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data: function() {
    return {
      dialogVisible: false,
      recommendReason: null,
    }
  },
  methods: {
    show: function(recommendReason) {
      // console.log(recommendReason)
      this.recommendReason = recommendReason
      this.dialogVisible = true
    },
    showProject: function(pro) {},
    showRadish: function(person) {
      window.open(`${window.frontend}/#/radish-detail-blank/${person._id}`, '_blank')
    },
  },
}
</script>
